import { IonButton, IonInput, IonLabel, IonList, IonItem, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonToolbar 
  ,IonGrid, IonInfiniteScroll, IonInfiniteScrollContent 
  ,IonRow ,IonIcon, IonAlert, IonCardHeader, IonCardTitle, IonCardSubtitle
  ,IonCol, IonModal, IonThumbnail, IonLoading
  ,IonListHeader, IonSearchbar, IonCard
} from '@ionic/react';
import React, { useState, useEffect, Component } from 'react';
//import { useParams } from 'react-router';
import './WpForm.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import { useParams } from 'react-router';
import ServerService from '../../../services/Server';
import { useHistory } from 'react-router-dom';
import { camera, trash, close, checkmarkCircle, qrCodeOutline, arrowRedo, closeCircle } from 'ionicons/icons';
import QrReader from 'react-qr-reader'
import { setAuthPersisted } from '../../../services/pinUtils';
type WpFormParams = {
  id:string, 
  dummy:string
}

const WpForm: React.FC = () => {
const server = new ServerService();
const history = useHistory();
server.setHistory(history);
const [accountName, setAccountName] = useState(server.accounts[server.activeAcc].name);
const {id, dummy} = useParams<WpFormParams>();
const [barCode, setBarcode] = useState("");
const [hideItem, setHideItem] = useState(true);
const name:string = "ID check";
const [fullname, setFullname] = useState("");
const [citizenid, setCitizenid] = useState("");
const [companyname, setCompanyname] = useState("");
const [pos, setPos] = useState("");
const [telephone, setTelephone] = useState("");
const [email, setEmail] = useState("");
const [trainingdate, setTrainingdate] = useState("");
const [profileimage, setProfileimage] = useState("");
const [showQrScan, setShowQrScan] = useState(true);
const [qrReader, setQrReader] = useState("");
const [alertMsg, setAlertMsg] = useState("");
const [showAlert1, setShowAlert1] = useState(false);
const [wkList, setWkList] = useState([]);
const [wkPageList, setWkPageList] = useState([]);
const [wkStatus, setWkStatus] = useState("");
const [showLoading, setShowLoading] = useState(true);

const [start, setStart] = useState(0);
const [limit, setLimit] = useState(10);
const [total, setTotal] = useState(0);
const [searchTerm, setSearchTerm] = useState("");
var c:string = '';

useEffect(() => {
  fetchWk(barCode, 0, 10, searchTerm);
  
  //console.log('useEffect');
  //generateItems();
}, [])


const generateItems = function(e:any) {
  setShowLoading(true);
  console.log('generateItems');
  const newItems = [];
  setStart(start+limit);
  fetchWk(barCode, start+limit, limit, searchTerm);
  e.target.complete();
 // setShowLoading(false);
  if(start >= total){
    //e.target.disabled = true;
    setShowLoading(false);
  }
  //(event.target as HTMLIonInfiniteScrollElement).complete();
};

const fetchWk = function(uuid:any, start:any, limit:any, searchTerm:any) {
  const data = {
    uuid: uuid,
    start : start,
    limit : limit,
    searchTerm : searchTerm
  }
  fetch(server.getFullUrl("wp/mb/listAllWorker", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {

      //setWkList(result.data);
      //setWkPageList(result.data);
      /*if(uuid!=null && uuid!=''){
        setWkList(result.data);
      }else if(searchTerm!=null && searchTerm!=''){
        setWkList(result.data);
      }else if(start >= 10){
        setWkList([...wkList, ...result.data]);
      }
      else if(start == 0){
        setWkList(result.data);
      }*/
      if(start == 0){
        setWkList(result.data);
      }else if(start >= 10){
        setWkList([...wkList, ...result.data]);
      }
      //setWkList([...wkList, ...result.data]);
      setWkStatus(result.status);
      setTotal(result.data[0].totalrowcount);
      setStart(start);
      setLimit(limit);
      console.log(result.status);
      setShowLoading(false);
      if(result.status=='E'){
        setAlertMsg('ไม่พบข้อมูล');
        setShowAlert1(true);
        setWkStatus("");
        return false;
      }
      console.log('fetchWk');
      //loadData();

    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {

}) 
}


const onScanQr = function(status:any) {
  setShowQrScan(false);
}
const fetchContractor = function(uuid:any) {
  const data = {
    cbarcode: uuid
  }
  fetch(server.getFullUrl("wp/mb/getContractor", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if(result.status=='E'){
        setAlertMsg('ไม่พบข้อมูล');
        setShowAlert1(true);
        setWkStatus("");
        return false;
      }else{
        setAuthPersisted();
        window.location.href = "/page/home/wp/wpIdCheck/"+uuid+"/d";
      }
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {

}) 
}
const onClickBarcode = async function(qr:any) {
  fetchContractor(qr);
  //fetchWk(qr, 0, 5);
 
  //window.location.href = "/page/home/wp/wpIdCheck/"+qr+"/d";
  /*  console.log('CLICK ' + qr);
   const data = {
    cbarcode:qr
  }
  
  fetch(server.getFullUrl("wp/mb/getContractor", data),server.getRequest())
   .then(res => res.json()
   .then(
     (result) => {
      onLoadStatus(result);
     },
     (error) => {

     }
  ).catch(e => {

  })
 ).catch(e => {

 }) */
  
 }
 const onLoadStatus = async function(result:any) {
  if(result.status == 'E'){
    setAlertMsg('ไม่พบข้อมูล');
    setShowAlert1(true);
     return false;
   }
   console.log(result.fullname);
  setFullname(result.fullname);
  setCitizenid(result.citizenid);
  setCompanyname(result.companyname);
  setTelephone(result.telephone);
  setPos(result.pos);
  setEmail(result.email);
  setTrainingdate(result.trainingcouse[0].trainingdate);
  setProfileimage(result.profileimage);
  setHideItem(false);
 }
 const handleScan = (data: any) => {
   //setShowAlert(true);
   //setQrReader(data);
   if (data!=null && data != '') {
    setShowQrScan(true);
    setBarcode(data);
    onClickBarcode(data);
   }
   
  
 }
 const handleError = (err: any) => {
  console.error(err)
 }
const onDownloadCert = function(nodeRef:any) {

  window.open(server.getFullUrl("rp/downloadFile?alf_ticket="+server.state.ticket+"&nodeRef="+nodeRef, null));
 
}
const onDownloadPermit = function(nodeRef:any) {

  window.open(server.getFullUrl("rp/downloadFile?alf_ticket="+server.state.ticket+"&nodeRef="+nodeRef, null));
 
}
const onSelectCardItem = function(id:any) {

  //setBarcode(id);
  setAuthPersisted();
  window.location.href = "/page/home/wp/wpIdCheck/"+id+"/"+dummy;
  //routerLink={"/page/home/wp/wpIdCheck/"+task.uuid+"/"+dummy}
}
const onSearch = async function(txt:any) {
  setWkList([]);
  setStart(0);
  setLimit(10);
  setSearchTerm(txt.target.value);
  fetchWk(barCode, 0, 10, txt.target.value);
 //setWkList([]);
}
  return (
    
    <IonPage>
     
      <IonHeader>
        <IonToolbar>    
          <IonButtons slot="start">
            <IonMenuButton />
            <OpenMenuButton />
          </IonButtons>      
         <div>
          <img className="idCheckImg1" src={"assets/img/contact-icon.png"}/> 
          <span className="span">  {name}</span>
         </div>
        </IonToolbar>
      </IonHeader>

      <IonContent>
      <IonAlert
          isOpen={showAlert1}
          onDidDismiss={() => setShowAlert1(false)}
          className='my-custom-class'
          header={barCode}
          subHeader={alertMsg}
          //message={'This is an alert message.'}
          buttons={['OK']}
        />
      <IonModal isOpen={!showQrScan}>
        <IonContent>
        <IonListHeader>
      <IonLabel>Scan QR Code</IonLabel>
      <IonButton onClick={() => setShowQrScan(true)}><IonIcon icon={closeCircle}></IonIcon></IonButton>
      </IonListHeader>

        <div hidden={showQrScan}>
          <QrReader
            delay={300}
            onError={handleError}
            onScan={handleScan}
            resolution={1024}
            style={{ width: '100%' }}
          />
        </div>

        </IonContent>
      </IonModal>
      
        <IonList>
        <IonItem>
            <IonLabel className="f-header p1" position="stacked">Barcode</IonLabel>
            <IonInput value={barCode} onIonChange={e => {setBarcode(e.detail.value)}}> </IonInput>
          </IonItem>
        </IonList>

<IonGrid>
  <IonRow>
    <IonCol>
      <IonButton color="secondary" expand="block" onClick={(e) => onScanQr("")}><IonIcon icon={qrCodeOutline}></IonIcon> <IonLabel>Scan QR</IonLabel></IonButton>
    </IonCol>
    <IonCol>
    <IonButton color="primary" expand="block" onClick={(e) => onClickBarcode(barCode)}><IonIcon icon={arrowRedo}></IonIcon>Submit</IonButton>
    </IonCol>
  </IonRow>
</IonGrid>
<IonLoading
        className="my-custom-class"
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={'Please wait...'}
        duration={2000}
      />
        <IonToolbar>
          <IonSearchbar onIonChange={e => {onSearch(e)}}></IonSearchbar>
        
        </IonToolbar>
<IonCard>
    <IonList>
    {wkList.map((task,i) => {
          var cert = false;
          var train = false;
          if(task.cert_img!=null){
            cert = true;
          }
          if(task.cert_train_img!=null){
            train = true;
          }
          console.log(cert);
          console.log(train);
          return(
            <IonItem key={i} >
              <IonThumbnail slot="start">
                <img className="img-profile2" src={task.profileimage}/ >
              </IonThumbnail>
              <IonCardHeader>
                  <IonCardTitle onClick={() => onSelectCardItem(task.uuid)}  >{task.fullname}</IonCardTitle>
                  <IonCardSubtitle onClick={() => onSelectCardItem(task.uuid)} >{task.companyname}</IonCardSubtitle>
                 {cert ? (
                  <IonButton hidden={!cert} onClick={() => onDownloadCert(task.cert_img)} fill={"clear"}> <img className="img1" src={"assets/img/pdf-document.png"} />&nbsp;ใบอบรมความปลอดภัย(6ชั่วโมง)</IonButton>
                 ) : ""}
                   {train ? (
                          <IonButton hidden={!train} onClick={() => onDownloadPermit(task.cert_train_img)} fill={"clear"}> <img className="img1" src={"assets/img/pdf-document.png"} />&nbsp;ใบอนุญาติ/ใบผ่านการอบรม</IonButton>
                    ) : ""}
            
                  
                </IonCardHeader>
            </IonItem>
    )})}
    </IonList>
            <IonInfiniteScroll
            onIonInfinite={e => {generateItems(e)}}
          >
            <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Loading more data..."></IonInfiniteScrollContent>
          </IonInfiniteScroll>

  </IonCard>

  

    </IonContent>
   
    </IonPage>
  );
};

export default WpForm;

